import React, { PropTypes } from 'react';
import { Link } from 'react-router';

export default class EditButton extends React.Component {

	render () {		
		return (
			<div>
				<div className="pull-right">
					<Link target="_blank" to={`/admin/documents/view/${this.props.id}`}>
						Editar Documento
					</Link>
				</div>
				<div className="clearfix" />						
				<hr />
			</div>			
		);
	}
}

EditButton.propTypes = {
	id: PropTypes.number
};


// WEBPACK FOOTER //
// ./src/components/Explorer/EditButton.js